import React from "react";
import { useOverrides, Override } from "@quarkly/components";
import { Text, Section, Strong } from "@quarkly/widgets";
const defaultProps = {
	"padding": "70px 0 30px 0",
	"md-background": "rgba(0, 0, 0, 0) url(https://uploads.quarkly.io/614ce40335c5c8001f7746e0/images/airplanemode_active.svg?v=2021-09-24T22:50:23.546Z) center 15%/125px no-repeat scroll padding-box",
	"md-padding": "40px 0 40px 0",
	"background": "linear-gradient(0deg,rgba(0,0,0,0) 0%,#ffffff 90.5%),rgba(0, 0, 0, 0) url(https://uploads.quarkly.io/67604c2fe5d27700189a24f0/images/Plant-Up.png?v=2024-12-16T16:23:23.563Z) center 19%/250px no-repeat scroll padding-box"
};
const overrides = {
	"text": {
		"kind": "Text",
		"props": {
			"max-width": "440px",
			"text-align": "center",
			"lg-font": "normal 600 28px/1.2 \"Manrope\", sans-serif",
			"lg-max-width": "340px",
			"md-margin": "0px 0px 52px 0px",
			"font": "--headline3",
			"color": "--dark",
			"margin": "0px 0px 2rem 0px",
			"children": "How to join us?"
		}
	},
	"text1": {
		"kind": "Text",
		"props": {
			"max-width": "640px",
			"lg-font": "normal 600 28px/1.2 \"Manrope\", sans-serif",
			"lg-max-width": "340px",
			"md-margin": "0px 0px 52px 0px",
			"margin": "0px 0px 76px 0px",
			"font": "--lead",
			"color": "--dark",
			"text-align": "left",
			"width": "100%",
			"children": <>
				Starting your own Green Bliss Café franchise is easier than you might think. Here’s how it works:
				<br />
				<br />
				<Strong
					overflow-wrap="normal"
					word-break="normal"
					white-space="normal"
					text-indent="0"
					text-overflow="clip"
					hyphens="manual"
					user-select="auto"
					pointer-events="auto"
				>
					Call Us
				</Strong>
				<br />
				Call Us and a member of our franchise development team will be in touch within 48 hours.
				<br />
				<br />
				<Strong
					overflow-wrap="normal"
					word-break="normal"
					white-space="normal"
					text-indent="0"
					text-overflow="clip"
					hyphens="manual"
					user-select="auto"
					pointer-events="auto"
				>
					Attend a Discovery Day
				</Strong>
				<br />
				Join us for an in-depth session where you’ll learn about our business model, meet our leadership team, and tour one of our thriving café locations.
				<br />
				<br />
				<Strong
					overflow-wrap="normal"
					word-break="normal"
					white-space="normal"
					text-indent="0"
					text-overflow="clip"
					hyphens="manual"
					user-select="auto"
					pointer-events="auto"
				>
					Sign the Agreement
				</Strong>
				<br />
				Once approved, you’ll sign the franchise agreement and officially become part of the Green Bliss family.
				<br />
				<br />
				<Strong
					overflow-wrap="normal"
					word-break="normal"
					white-space="normal"
					text-indent="0"
					text-overflow="clip"
					hyphens="manual"
					user-select="auto"
					pointer-events="auto"
				>
					Open Your Café
				</Strong>
				<br />
				From build-out to grand opening, we’ll guide you through every step of the process. With our support, you’ll be ready to welcome customers and start building your dream business.
			</>
		}
	}
};

const Cta = props => {
	const {
		override,
		children,
		rest
	} = useOverrides(props, overrides, defaultProps);
	return <Section {...rest}>
		<Override slot="SectionContent" align-items="center" justify-content="center" />
		<Text {...override("text")} />
		<Text {...override("text1")} />
		{children}
	</Section>;
};

Object.assign(Cta, { ...Section,
	defaultProps,
	overrides
});
export default Cta;